import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOSchema from '@/components/feature/SEOSchema';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <SEOSchema
        type="page"
        title="Privacy Policy - KakobuySheet Kakobuy Spreadsheet Resource"
        description="KakobuySheet Privacy Policy. Learn how we handle visitor information, cookies, and external links on our Kakobuy Spreadsheet directory website at kakobuy.boutique."
        url="https://kakobuy.boutique/privacy"
        dateModified="2026-06-25"
      />
      <Navbar />
      <main className="pt-24 pb-16 md:pt-28 md:pb-20">
        <div className="max-w-[900px] mx-auto px-6 md:px-10">
          <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-400 mb-6">
            <Link to="/" className="hover:text-primary-600 transition-colors">Home</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-700 font-medium">Privacy Policy</span>
          </nav>
          <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mb-6">Privacy Policy</h1>
          <div className="prose-custom space-y-5 text-foreground-700 leading-relaxed text-base md:text-lg">
            <p>This Privacy Policy explains how KakobuySheet handles information when you visit our website at kakobuy.boutique, a resource dedicated to providing organized <strong>Kakobuy Spreadsheet</strong> links and shopping guides.</p>
            <h2 className="text-2xl font-heading font-bold text-foreground-950 mt-8 mb-4">Information Collection</h2>
            <p>We do not collect personal information from visitors. Our website serves as a directory and informational resource for <strong>Kakobuy Spreadsheet</strong> links. We do not use cookies for tracking purposes, and we do not require user accounts or registration to access any of our content.</p>
            <h2 className="text-2xl font-heading font-bold text-foreground-950 mt-8 mb-4">External Links</h2>
            <p>Our website contains links to external sites, primarily kaspreadsheet.com, which hosts the actual <strong>Kakobuy Spreadsheet</strong> resources. We are not responsible for the privacy practices of external websites. All external links open in new tabs and are clearly marked.</p>
            <h2 className="text-2xl font-heading font-bold text-foreground-950 mt-8 mb-4">Contact</h2>
            <p>For questions about this privacy policy, please visit our <Link to="/contact" className="text-primary-600 hover:text-primary-700 underline">Contact page</Link>.</p>
          </div>
          <div className="mt-8">
            <Link to="/" className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 font-medium text-sm">
              <i className="ri-arrow-left-line"></i> Back to Home
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}